<template>
  <div class="details-header">
    <div class="left">
      <slot name="fullName"></slot>
      <slot name="statusDropdown"></slot>
      <slot name="summary"></slot>
    </div>
    <div class="right">
      <slot name="statusStepper"></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped>
.details-header {
  display: flex;
  width: 100%;
  padding: 22px 0px 22px 19px;
  gap: 22px;
	position: relative;
}

.left {
  width: calc(100% - 500px);
  flex: 1;
}

.right {
  width: 500px;
	height: 108px;
	right: 0;
	position: absolute;
}

@media screen and (max-width: 1150px) {
  .details-header {
    flex-direction: column;
  }
	.right {
		position: relative;
	}
  .left,
  .right {
    width: 100%;
  }
}

@media screen and (max-width: 960px) {
  .details-header {
    padding-left: 0;
  }
}
</style>
